const ApiUrl = "https://voetbal-backend-staging.aletho.nl/";
export const ImageUrl = "https://voetbal-backend-staging.aletho.nl/images/";

export default ApiUrl;